const getConcatValueForCoordinate = (coordinates, limitLabel) => {
  function getZeroAppended(x) {
    return (100 + parseFloat(x || "0")).toString().slice(1);
  }

  if (!coordinates || coordinates === "") {
    return {};
  }

  const splitText = coordinates.split(":");
  return {
    [limitLabel]: parseFloat(
      splitText[0]
        .concat(getZeroAppended(splitText[1]))
        .concat(getZeroAppended(splitText[2]))
    ),
  };
};

export const getCombinedFilters = (filters) => {
  const raDecColumns = ["ra", "dec"];
  let newFilters = Object.keys(filters).reduce((acc, val) => {
    if (raDecColumns.indexOf(val) === -1) {
      acc[val] = filters[val];
    }
    return acc;
  }, {});

  if (filters["ra"]) {
    newFilters["ra_hms_text"] = {
      ...getConcatValueForCoordinate(filters["ra"]["min"], "min"),
      ...getConcatValueForCoordinate(filters["ra"]["max"], "max"),
    };
  }
  if (filters["dec"]) {
    newFilters["dec_dms_text"] = {
      ...getConcatValueForCoordinate(filters["dec"]["min"], "min"),
      ...getConcatValueForCoordinate(filters["dec"]["max"], "max"),
    };
  }
  return newFilters;
};

export const applyFilter = (data, filters) => {
  return data.filter((currentRow) =>
    Object.keys(filters).every((key) => {
      let { min, max, type, value, dtype, index } = filters[key];
      let returnValue = true;

      if (!(key in currentRow)) {
        return returnValue;
      }

      let currentValue = currentRow[key];
      if(dtype === "array") {
        currentValue = currentValue[index];
      }

      if (
        type === "select" &&
        key in currentRow &&
        value !== undefined &&
        value !== "ANY"
      ) {
        return returnValue && currentRow[key].toString() === value.toString();
      }

      if (type === "multi-select" && value !== undefined) {
        return returnValue && value[currentValue] !== false;
      }

      if (type === "full-text") {
        return returnValue && value === currentValue;
      }

      if (min !== undefined) {
        returnValue = returnValue && currentValue >= min;
      }

      if (max !== undefined) {
        returnValue = returnValue && currentValue <= max;
      }
      return returnValue;
    })
  );
};
